import { render, staticRenderFns } from "./AddCalendarEvent.vue?vue&type=template&id=63f53b5c&"
import script from "./AddCalendarEvent.vue?vue&type=script&lang=js&"
export * from "./AddCalendarEvent.vue?vue&type=script&lang=js&"
import style0 from "./AddCalendarEvent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports